// @ts-nocheck
/**
 * Shared phone field helpers for contact forms.
 */
(function () {
  function getPhoneLib() {
    return window.libphonenumber;
  }

  function waitForLib(timeoutMs = 8000) {
    return new Promise((resolve) => {
      const start = Date.now();

      const tick = () => {
        const lib = getPhoneLib();
        if (lib && typeof lib.parsePhoneNumberFromString === 'function') {
          resolve(lib);
          return;
        }
        if (Date.now() - start >= timeoutMs) {
          resolve(null);
          return;
        }
        requestAnimationFrame(tick);
      };

      tick();
    });
  }

  function normalizeDigits(rawNumber) {
    return rawNumber.replace(/\D+/g, '');
  }

  function isValidUsPhone(digits) {
    return digits.length === 10 || (digits.length === 11 && digits.startsWith('1'));
  }

  function toUsE164(digits) {
    return digits.length === 10 ? `+1${digits}` : `+${digits}`;
  }

  function phoneNumberIsValid(parsed) {
    if (!parsed) return false;
    if (typeof parsed.isValid === 'function') return parsed.isValid();
    return Boolean(parsed.isValid);
  }

  async function populateCountryOptions(selectEl) {
    if (!selectEl) return;

    const lib = await waitForLib();
    if (!lib || typeof lib.getCountries !== 'function' || typeof lib.getCountryCallingCode !== 'function') {
      return;
    }

    const currentCountry = selectEl.value || 'US';
    const countries = lib.getCountries();
    const displayNames = typeof Intl !== 'undefined' && typeof Intl.DisplayNames === 'function'
      ? new Intl.DisplayNames(['en'], { type: 'region' })
      : null;

    selectEl.innerHTML = '';
    countries
      .slice()
      .sort((a, b) => {
        const aName = displayNames?.of(a) || a;
        const bName = displayNames?.of(b) || b;
        return aName.localeCompare(bName);
      })
      .forEach((countryCode) => {
        const dialCode = lib.getCountryCallingCode(countryCode);
        const option = document.createElement('option');
        option.value = countryCode;
        option.textContent = `${displayNames?.of(countryCode) || countryCode} (+${dialCode})`;
        if (countryCode === currentCountry) {
          option.selected = true;
        }
        selectEl.append(option);
      });

    if (!selectEl.value) {
      selectEl.value = 'US';
    }
  }

  function syncValue({ phoneInput, phoneCountry, phoneE164Input, markInvalid, errorClass }) {
    if (!phoneInput || !phoneCountry || !phoneE164Input) {
      return { valid: true, e164: '' };
    }

    const rawNumber = phoneInput.value.trim();
    const selectedCountry = phoneCountry.value || 'US';
    const lib = getPhoneLib();

    const setInvalid = () => {
      if (markInvalid) phoneInput.classList.add(errorClass);
    };
    const clearInvalid = () => phoneInput.classList.remove(errorClass);

    if (!rawNumber) {
      phoneE164Input.value = '';
      setInvalid();
      return { valid: false, e164: '' };
    }

    if (lib && typeof lib.parsePhoneNumberFromString === 'function') {
      const parsed = lib.parsePhoneNumberFromString(rawNumber, selectedCountry);
      if (phoneNumberIsValid(parsed)) {
        phoneE164Input.value = parsed.number;
        clearInvalid();
        return { valid: true, e164: parsed.number };
      }
    }

    const digits = normalizeDigits(rawNumber);
    if (isValidUsPhone(digits)) {
      const e164 = toUsE164(digits);
      phoneE164Input.value = e164;
      clearInvalid();
      return { valid: true, e164 };
    }

    if (digits.length >= 6 && digits.length <= 15) {
      phoneE164Input.value = `+${digits}`;
      clearInvalid();
      return { valid: true, e164: phoneE164Input.value };
    }

    phoneE164Input.value = '';
    setInvalid();
    return { valid: false, e164: '' };
  }

  window.PSPhoneField = {
    waitForLib,
    populateCountryOptions,
    syncValue
  };
})();
